import { motion } from "framer-motion";
import { SERVICES } from "@/data/content";
import { ArrowUpRight, Sparkles, Smile, Stethoscope, Zap, Crown, Palette, Sun, AlignJustify, Anchor, Wrench, Baby, Scissors } from "lucide-react";

const ICON_MAP = [Stethoscope, Sparkles, Zap, Palette, Crown, Smile, Sun, AlignJustify, Anchor, Wrench, Baby, Scissors];

export default function Services() {
  return (
    <section id="services" className="py-20 md:py-32 bg-[hsl(var(--bg-2))]/60" data-testid="services">
      <div className="max-w-[1440px] mx-auto px-5 md:px-12">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <div className="eyebrow mb-4 justify-center">Our services</div>
          <h2 className="font-display text-3xl md:text-5xl lg:text-[3.4rem] leading-[1.05] tracking-[-0.02em]">
            High-quality dentistry, <br /><span className="text-[hsl(var(--primary))]">for every smile.</span>
          </h2>
          <p className="mt-5 md:mt-6 text-[15px] md:text-base text-[hsl(var(--ink-soft))]">
            Twelve treatments delivered in a single calm room — from preventive cleaning to full-mouth reconstruction.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {SERVICES.map((s, i) => {
            const Icon = ICON_MAP[i % ICON_MAP.length];
            return (
              <motion.article
                key={s.n}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.55, delay: (i % 4) * 0.06 }}
                className="card-soft p-5 md:p-7 group cursor-default"
                data-testid={`service-${s.n}`}
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="w-14 h-14 rounded-2xl bg-[hsl(var(--primary-light))] text-[hsl(var(--primary-dark))] flex items-center justify-center transition-colors duration-500 group-hover:bg-[hsl(var(--primary))] group-hover:text-white">
                    <Icon size={24} strokeWidth={1.7} />
                  </div>
                  <span className="font-mono text-[11px] text-[hsl(var(--primary))]">{s.n}</span>
                </div>
                <h3 className="font-display text-lg leading-tight mb-2">{s.title}</h3>
                <p className="text-[13px] text-[hsl(var(--ink-soft))] leading-relaxed">{s.desc}</p>
                <div className="mt-5 pt-4 border-t border-[hsl(var(--line))]/70 flex items-center justify-between text-[hsl(var(--primary-dark))]">
                  <span className="text-[12px] font-medium">Andheri · Powai</span>
                  <ArrowUpRight size={16} className="transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" />
                </div>
              </motion.article>
            );
          })}
        </div>

        <div className="mt-14 text-center">
          <a href="#book" className="btn-pill btn-solid">
            Book a consultation <span className="arrow"><ArrowUpRight size={16} /></span>
          </a>
        </div>
      </div>
    </section>
  );
}
